<template>
  <ValidationProvider
    :bail="bail"
    :name="$attrs.name"
    :rules="rules"
    :vid="vid"
    mode="eager"
    v-slot="{ valid, errors }"
  >
    <b-form-group v-bind="$attrs">
      <b-form-input
        v-if="!currencyType"
        v-model="innerValue"
        v-bind="$attrs"
        :type="type"
        :name="name"
        class="no-border input-lg"
        :disabled="disabled"
        :placeholder="placeholder"
        :state="errors[0] ? false : (valid ? true : null)"
      ></b-form-input>
      <b-form-invalid-feedback id="inputLiveFeedback">{{ errors[0] }}</b-form-invalid-feedback>
    </b-form-group>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from "vee-validate";

export default {
  components: {
    ValidationProvider
  },
  props: {
    vid: {
      type: String
    },
    rules: {
      type: [Object, String],
      default: ""
    },
    // must be included in props
    value: {
      type: null
    },
    bail: { type: Boolean, default: true },
    placeholder: String,
    disabled: { type: Boolean, default: false },
    type: {
      type: String,
      default: "text"
    },
    name: String,
    currencyType: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    innerValue: "",
    currency:""
  }),

  methods:{
    handleBlur(e){
      this.$emit("input", parseInt(this.currency));
      this.currency=this.$options.filters.number(e.target.value,'0,0')
    },
    handleFocus(e){
      this.currency=parseInt(e.target.value.replace(/,/g,""))
    }
  },
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit("input", newVal);
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal;
    }
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  }
};
</script>
